import React from 'react';
import "./Loader.scss";

import { TfiReload } from "react-icons/tfi";

const Loader = () => {
  return (
    <div className='global-loader'>
        <TfiReload />
    </div>
  )
}

export default Loader